import React from "react";
import { Button } from "@telia/teddy";
import { connect } from "react-redux";
import { RootState } from "../../../../../../models";
import { isBankIdVerified } from "../../../../authentication/state/selectors";
import { FORM_ID } from "../../../../../../constants";
import * as LOADING_SELECTORS from "../../../../loading/state/selectors";
import * as TELIA_PLAY_AT from "../../../state/actionTypes";
import { getAvailableAddresses, getMockAddress } from "../../../state/selectors";

interface StateProps {
    canContinue: boolean;
    isSubmitting: boolean;
}

type CustomerContinueButtonProps = StateProps;

const CustomerContinueButton: React.FC<CustomerContinueButtonProps> = ({ canContinue, isSubmitting }) => {
    return (
        <Button
            id="customer-form-button"
            form={FORM_ID.PERSONAL_DETAILS_TELIA_PLAY}
            variant="primary"
            disabled={!canContinue || isSubmitting}
            type="submit"
        >
            Neste
        </Button>
    );
};

const mapStateToProps = (state: RootState): StateProps => {
    const isFetchingWorkflowData = [
        TELIA_PLAY_AT.TELIA_PLAY_SEARCH_ADDRESSES,
        TELIA_PLAY_AT.TELIA_PLAY_SET_CONTACT_INFO,
        TELIA_PLAY_AT.TELIA_PLAY_GET_VAID_FROM_ADDRESS,
        TELIA_PLAY_AT.TELIA_PLAY_SELECT_PACKAGE,
        TELIA_PLAY_AT.TELIA_PLAY_SELECT_MOCK_ADDRESS,
    ].some((actionType) => LOADING_SELECTORS.isTypeLoading(state, actionType));
    return {
        canContinue:
            isBankIdVerified(state) &&
            ((getAvailableAddresses(state)?.length ?? 0) > 0 || getMockAddress(state) !== null) &&
            state.teliaPlay?.isSelectedPackageUnavailable !== true,
        isSubmitting: state.teliaPlay?.isCustomerSubmissionPending === true || isFetchingWorkflowData,
    };
};

export default connect(mapStateToProps)(CustomerContinueButton);
